let currentPaginationPage = 1;
let canPass = true;
function ensureInfiniteLoader() {
  let loader = document.getElementById('infinite-loader');
  if (!loader) {
    loader = document.createElement('div');
    loader.id = 'infinite-loader';
    loader.innerHTML = '<div class="lds-dual-ring"></div>';
    const grid = document.querySelector('.load-more-grid');
    if (grid) grid.parentNode.insertBefore(loader, grid.nextSibling);
  }
  return loader;
}

const showLoader = () => {
  const loader = ensureInfiniteLoader();
  loader.style.display = 'block';
};
const hideLoader = () => {
  const loader = document.getElementById('infinite-loader');
  if (loader) loader.style.display = 'none';
};

const loadItems = async (button, needReturn) => {
  if (canPass || needReturn) {
    canPass = false;
    showLoader();
    currentPaginationPage++;
    localStorage.setItem('currentPage', currentPaginationPage);
    const page = localStorage.getItem('currentPage');
    //console.log('page: ' + page + '/' + currentPaginationPage);
    const totalPages = parseInt(document.querySelector('[data-total-pages]').value);
    let currentPageScroll = currentPaginationPage + 1;
    let toReturn;
    const nextUrl = document.querySelector('[data-next-url]')
      .value
      .replace(/page=[0-9]+/, 'page=' + currentPaginationPage);
    const nextUrlScroll = document.querySelector('[data-next-url]')
      .value
      .replace(/page=[0-9]+/, 'page=' + currentPageScroll);
    document.querySelector('[data-current-page]').value = currentPaginationPage;

    button.setAttribute('disabled', '');
    button.classList.add('loading');

    try {
      const response = await fetch(nextUrl, { method: 'GET' });
      if (!response.ok) throw new Error('Network response was not ok');
      const responseHTML = await response.text();
      const parser = new DOMParser();
      const doc = parser.parseFromString(responseHTML, 'text/html');
      const newContent = doc.querySelector('.load-more-grid')?.innerHTML;
      if (!needReturn) {
        document.querySelector('.load-more-grid').insertAdjacentHTML('beforeend', newContent);
        if (typeof colorSwatches === 'function') colorSwatches();
      } else {
        toReturn = newContent;
      }
    } catch (e) {
      console.error(e);
    } finally {
      canPass = true;
      hideLoader();
      if (currentPaginationPage <= totalPages) {
        const scollData = document.querySelector('.infinite-scroll__data');
        if (scollData && currentPaginationPage != totalPages) {
          const nextUrlInput = scollData.querySelector('input[data-next-url]');
          nextUrlInput.dataset.nextUrl = nextUrlScroll;
          nextUrlInput.value = nextUrlScroll;
          const currentPageInput = scollData.querySelector('input[data-current-page]');
          currentPageInput.dataset.currentPaginationPage = currentPaginationPage;
          currentPageInput.value = currentPaginationPage;
          checkVisibility();
        }
        button.removeAttribute('disabled');
        button.classList.remove('loading');
        if (currentPaginationPage == totalPages) {
          button.remove();
        }
      }
    }
    return toReturn;
  }
};

const checkVisibility = () => {
  if (window._infiniteScrollObserver) {
    window._infiniteScrollObserver.disconnect();
  }
  const spinnerList = document.querySelectorAll('.js-infinite-scroll');
  const lastSpinner = spinnerList[spinnerList.length - 1];
  const totalPages = parseInt(document.querySelector('[data-total-pages]').value);
  if (currentPaginationPage >= totalPages) {
    return;
  }
  if (!lastSpinner) return;
  const sectionObserver = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        loadItems(lastSpinner);
      }
    });
  }, {
    root: null,
    rootMargin: '0px 0px 300px 0px',
    threshold: 0
  });
  sectionObserver.observe(lastSpinner);
  window._infiniteScrollObserver = sectionObserver;
};

function loadMore() {
 
  checkVisibility();
}

(function () {
  loadMore();
  checkVisibility();
})();
